module.exports = __webpack_public_path__ + "img/changeWidth-2@2x.3386e9c.webp";